<template>
  <div class="lawoffswiper">
    <el-carousel trigger="click" height="320px" arrow="never">
      <el-carousel-item v-for="item in 4" :key="item"  @click.native="tojump">
        <div class="swiimg">
          <img src="../../../assets/findlawchild/finglawoffbanner.png" />
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  methods: {
    tojump(item){
      console.log(item);
      this.$router.push({
        path:'/findLawyers/seafirms'
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.lawoffswiper {
  width: 100%;
  height: 320px;
  background-color: #e7e7e7;
  ::v-deep   .el-carousel__button {
      width: 8px;
      height: 8px;
      border-radius: 50%;
    
  }
  .swiimg {
    img {
      width: 100%;
      height: 320px;
    }
  }
}
</style>